import { render, staticRenderFns } from "./calendarSide.vue?vue&type=template&id=7545ed4b&scoped=true&"
import script from "./calendarSide.vue?vue&type=script&lang=js&"
export * from "./calendarSide.vue?vue&type=script&lang=js&"
import style0 from "./calendarSide.vue?vue&type=style&index=0&id=7545ed4b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7545ed4b",
  null
  
)

export default component.exports